<script lang="ts">
    import type {Link} from '../../../typings/portaro.be.types';
    import KpLinkButton from './KpLinkButton.svelte';
    import KpDropdownButton from '../../ui-components/dropdown/KpDropdownButton.svelte';
    import KpLink from './KpLink.svelte';

    export let links: Link[];
    export let dropdownButtonText: string;
    export let singleButtonOverwriteLinkText: string = null;
    export let singleButtonPrefixText: string = null;
    export let buttonSize: 'sm' | 'md' | 'lg' = 'md';
    export let forceDropdown = false;


    function adjustLink(link: Link): Link {
        if (singleButtonOverwriteLinkText) {
            link.text = singleButtonOverwriteLinkText;
        }

        if (singleButtonPrefixText) {
            link.text = singleButtonPrefixText + link.text;
        }

        return link;
    }
</script>

<template>
    {#if links.length === 1 && !forceDropdown}
        <KpLinkButton link={adjustLink(links[0])} {buttonSize} buttonStyle="default"/>
    {/if}
    {#if links.length > 1 || forceDropdown}
        <KpDropdownButton {buttonSize} buttonStyle="default">
            <svelte:fragment slot="button">
                {dropdownButtonText}
                <span class="caret"></span>
            </svelte:fragment>
            <svelte:fragment slot="menu">
                {#each links as link}
                    <li>
                        {#if link.note}
                            <KpLink {link}><small slot="note" class="text-muted">{link.note}</small></KpLink>
                        {:else}
                            <KpLink {link}/>
                        {/if}
                    </li>
                {/each}
            </svelte:fragment>
        </KpDropdownButton>
    {/if}
</template>